export default [
	{
	title: 'Accueil',
	route: 'home',
	icon: 'HomeIcon',
	},
	{
	title: 'BOXEA',
	route: 'boxea',
	icon: '',
	},
	{
	title: 'IZIBOX Ouest',
	route: 'izibox',
	icon: '',
	},
	{
	title: 'IZIBOX Nord Est',
	route: 'izibox2',
	icon: '',
	},
	{
	title: 'DOMICIALIZ',
	route: 'domicializ',
	icon: '',
	},
]
